const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]'),
    
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();
    }

    readMore(){
        if(selectors.readMoreBtn){
            selectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
                if(readMoreEle){ 
                    if(selectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }
}
window.onload = () => {
    typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();
}
 

var collection_filtering = document.querySelector('[data-filter-collection]')
var filteringOne = collection_filtering ;

_replaceCategoryFilter = () => {
    if (document.querySelector('.snize-search-results') != null){
        
        if(document.querySelector('.snize-filters-sidebar') != null )
        document.querySelector('.snize-filters-sidebar').prepend(filteringOne)
         
        if(document.querySelector('#snize_filters_block') != null)
        document.querySelector('#snize_filters_block').insertAdjacentElement('afterend',filteringOne)

        filteringOne.classList.remove("d-none");
        let productSubCount = document.querySelector('.snize-products-tab-total').textContent;
        document.querySelector('[data-productCount]').innerHTML = `( ${productSubCount} items)`
    }
 }




_quickView = () => {
    document.querySelectorAll(".snize-quick-view-button").forEach( element => {
        element.onclick = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            let handle = element.closest('a').getAttribute('href')
        const handle_product = handle.split("/");
        let product_handle = handle_product.slice(-1)[0]
        element.className += " quickshop--button"
        element.setAttribute('data-handle', product_handle)
        document.querySelector('[data-searchanise_quickshop]').setAttribute('data-handle', product_handle)
        document.querySelector('[data-searchanise_quickshop]').click();
        }
    })

    document.querySelectorAll(".snize-view-product-button").forEach( element => {
        element.onclick = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            let handle = element.closest('a').getAttribute('href')
        const handle_product = handle.split("/");
        let product_handle = handle_product.slice(-1)[0]
        element.className += " quickshop--button"
        element.setAttribute('data-handle', product_handle)
        document.querySelector('[data-searchanise_quickshop]').setAttribute('data-handle', product_handle)
        document.querySelector('[data-searchanise_quickshop]').click();
        }
    })
}

const targetNode = document.querySelector('[data-collection-main]');
const config = { childList: true, subtree: true };

const callback = function(mutationsList, observer) {
    for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            observer.disconnect();
            _replaceCategoryFilter();
            _quickView();
            // if (document.querySelector('.snize-filters-title') != null) {
            //     document.querySelector('.filter-collection').insertAdjacentElement('beforebegin',document.querySelector('.snize-filters-title'))
            // }
             observer.observe(targetNode, config);
        }
    }
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, config);

var horizontalIntrval = setInterval(() => {
    var collection_title = document.querySelector('#collection_title')  
    collection_title.classList.remove('d-none')
    // document.querySelector('.snize-horizontal-left').appendChild(collection_title)
    if(document.querySelector('.snize-horizontal-left') != null ){
        collection_title.classList.remove('d-none')
        document.querySelector('.snize-horizontal-left').appendChild(collection_title);
       
        
    }
    
    if(document.querySelector('.snize-horizontal-left'))
    {
        clearInterval(horizontalIntrval);
    }
}, 1000);

_filterDropdown = () =>{
   if (document.querySelector('#snize-overlay-mobile-filters-dialog') != null || document.querySelector('#snize-overlay-mobile-sortby-dialog') != null )  {
           if ((document.querySelector('#snize-overlay-mobile-filters-dialog') != null && document.querySelector('#snize-overlay-mobile-filters-dialog').style.display == 'block') || document.querySelector('#snize-overlay-mobile-sortby-dialog').style.display == 'block') {
               if (document.querySelector('#dummy-chat-button-iframe') != null) {
                   document.querySelector('#dummy-chat-button-iframe').classList.add('d-none')
               }
           }else{
               if (document.querySelector('#dummy-chat-button-iframe') != null) {
                   document.querySelector('#dummy-chat-button-iframe').classList.remove('d-none')
               }
           }
   }
}
setInterval(() => {
    _filterDropdown()
}, 1000);
